import EditCommentModal from './edit-comment-modal-view'
export default EditCommentModal
